// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulpu2gc{gap:var(--ds-space-100,8px)}._18zr1ejb{padding-inline:var(--ds-space-300,24px)}\n._1bahesu3{justify-content:flex-end}\n._1e0c1txw{display:flex}\n._1pfhmufe{margin-block-start:var(--_t7lu6v)}\n._1q51pxbi{padding-block-start:var(--ds-space-200,1pc)}\n._4cvr1h6o{align-items:center}\n._85i51ejb{padding-block-end:var(--ds-space-300,24px)}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
